<template>
  <div>
    <!-- 搜索区 -->
    <DirectRecordSearch
      :searchOptions="searchOptions"
      :searchData="searchParams"
      @onSearch="getList"
      @clearAll="onSearch"
    />
    <el-button type="primary" class="mb20" @click="create">新建</el-button>
     <c-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="searchParams"
        :tabIndexPageReset="true"
        :pager="true"
        :api="getFaceClassList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <!-- <template v-slot:col-isAdjunct="scope">
          {{ scope.row.isAdjunct === 1 ? '是' : '否' }}
        </template> -->
        <!-- 自定义列表内容 -->
        <template v-slot:col-state="scope">
          <p>{{ scope.row.status === 1 ? '已启用' : '已停用' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 2 ? '启用' : '停用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.status === 1"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </c-table>
    <Handle ref='dialog' :editParams='editParams' @success='success'></Handle>
  </div>
</template>

<script>
import CTable from '@/components/PublicTable';
import DirectRecordSearch from "@/components/Search/index";
import Handle from "./handle.vue";
import { getFaceClassList,updateFaceClassStatus } from '@/api/api'

export default {
  components: {
    DirectRecordSearch,
    Handle,
    CTable
  },
  data() {
    return {
      updateFaceClassStatus,
      getFaceClassList,
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        fieldList: [
          // { label: '排序号', value: 'id' },
          { label: '分类名称', value: 'name'},
          { label: '状态', value: 'state', type: 'slot' },
          { label: '操作人', value: 'insertName'},
          { label: '操作时间', value: 'lastUpdateDate'  },
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'state', show: true, slot: true },
            // { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
            { label: '编辑', type: 'text', event: 'edit', show: true },
          ]
        }
      },
      // 搜索表单配置项
      searchOptions: [
        // {
        //   type: "select",
        //   label: "等级：",
        //   prop: "acceptBankLevelType",
        //   width: "230px",
        //   placeholder: "请选择等级",
        //   // data: getAcceptBankLevelType(),
        // },
        {
          type: "input",
          label: "分类名称",
          prop: "name",
          width: "230px",
          placeholder: "请输入分类名称",
          // querySearchAsync: querySearchAsync,
        },
        // {
        //   type: "input",
        //   label: "行号：",
        //   prop: "bankNo",
        //   width: "230px",
        //   placeholder: "请输入行号",
        // },
      ],
      searchParams: {
      },
      editParams:{},

    };
  },
  mounted(){
    this.getList();
  },
  methods: {
    create(){
      this.$refs.dialog.setOpacity(true)
    },
    success(){
      this.editParams={};
      this.getList()
    },
     // 通过随机数请求列表
    getList(params) {
      this.searchParams = params;
      this.tableInfo.refresh = Math.random();
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
    handleClick(event,row){
      console.log(row)
      if (event === 'edit') {
        this.create();
        this.editParams = row;
        // this.$refs.cooperatorDialog.init(row);
        // this.dialogVisible = true;
      } else if (event === 'state') {
        updateFaceClassStatus({
          id: row.id,
          status:row.status === 1 ? 2 : 1
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success('成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteTrain({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    // 查询
    onSearch(data) {
        console.log(data)
    },
    // 切换选择
    changeTableSelection(val) {
      console.log(val);
    },
    // 操作
    showDetail(row) {
      console.log(row);
    },
    getAcceptBankLevelType(){

    }
  },
};
</script>
<style lang='scss' scoped>
.mb20{
  margin-bottom: 20px;
}
</style>
